import React, { useEffect, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebaseConfig";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer
} from "recharts";

const Statistics = () => {
  const [issues, setIssues] = useState([]);

  useEffect(() => {
    const q = query(collection(db, "issues"), where("resolved", "==", false));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setIssues(data);
    });
    return () => unsubscribe();
  }, []);

  const tesisCounts = issues.reduce((acc, item) => {
    const key = item.tesis || "Belirtilmemiş";
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  const issueTypeCounts = issues.reduce((acc, item) => {
    const key = item.issue || "Bilinmiyor";
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  const longestWaiting = [...issues].sort((a, b) => a.date.seconds - b.date.seconds).slice(0, 5);

  const tesisChartData = Object.entries(tesisCounts).map(([name, count]) => ({ name, count }));
  const issueTypeData = Object.entries(issueTypeCounts).map(([name, value]) => ({ name, value }));

  const COLORS = ["#8884d8", "#82ca9d", "#ffc658", "#ff7f50", "#8dd1e1", "#d0ed57"];

  const handlePieClick = (data) => {
    if (!data?.name) return;

    const ilgiliPlakalar = issues
      .filter((issue) => (issue.issue || "Bilinmiyor") === data.name)
      .map((issue) => issue.plate)
      .join("\n");

    const yeniPencere = window.open("", "_blank", "width=400,height=600");
    yeniPencere.document.write(`
      <html>
        <head>
          <title>İlgili Plakalar</title>
          <style>
            body { font-family: Arial; padding: 20px; }
            button {
              background-color: #2563eb;
              color: white;
              border: none;
              padding: 8px 12px;
              border-radius: 5px;
              margin-bottom: 12px;
              cursor: pointer;
            }
          </style>
        </head>
        <body>
          <h3>${data.name} - İlgili Plakalar</h3>
          <button onclick="navigator.clipboard.writeText(document.querySelector('pre').innerText); alert('Panoya kopyalandı!')">📋 Panoya Kopyala</button>
          <pre>${ilgiliPlakalar}</pre>
        </body>
      </html>
    `);
    yeniPencere.document.close();
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4 text-center">İstatistikler</h2>

      <div className="mb-8">
        <h3 className="text-lg font-semibold mb-2">Tesislere Göre Açık Eksiklik Sayısı</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={tesisChartData} layout="vertical">
            <XAxis type="number" allowDecimals={false} />
            <YAxis type="category" dataKey="name" width={120} />
            <Tooltip />
            <Legend />
            <Bar dataKey="count" fill="#8884d8" name="Açık Eksiklik" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="mb-8">
        <h3 className="text-lg font-semibold mb-2">Eksiklik Türü Dağılımı</h3>
        <div style={{ height: 420 }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={issueTypeData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="48%"
                outerRadius={100}
                label
                onClick={handlePieClick}
              >
                {issueTypeData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend layout="horizontal" verticalAlign="bottom" align="center" />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="mb-8">
        <h3 className="text-lg font-semibold mb-2">En Uzun Süredir Bekleyen Eksiklikler</h3>
        <ul className="list-disc list-inside">
          {longestWaiting.map((item) => {
            const days = Math.ceil((Date.now() - item.date.seconds * 1000) / (1000 * 60 * 60 * 24));
            return (
              <li key={item.id} className="text-red-600">
                {item.plate} - {item.issue} ({days} güdür bekliyor)
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Statistics;
